import React, { createContext, useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import { fetchWithTimeout } from "./utils/RpcUtils";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Rehydrate user from backend on reload
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetchWithTimeout("/itvs-site/me", {
          credentials: "include", 
        });
        if (res.ok) {
          const data = await res.json();
          setUser(data);
        } else {
          setUser(null);
        }
      } catch (err) {
        console.error("Error fetching /me:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = async () => {
    try {
      await fetchWithTimeout("/itvs-site/logout", { method: "POST", credentials: "include" });
    } catch (err) {
      console.error("Logout failed:", err);
    }
    setUser(null);
  };

  const setLoginRole = async (userObj, role) => {
    try {
      await fetchWithTimeout(`/itvs-site/setRole?role=${role}`, { credentials: "include" });
    } catch (err) {
      console.error("setRole failed:", err);
    }
    const updatedUser = { ...userObj, loginRole: role };
    setUser(updatedUser);
  };

  const setCaringFor = async (userObj, caringFor) => {
    try {
      await fetchWithTimeout(`/itvs-site/setCaringFor?caringFor=${caringFor._id}`, { credentials: "include" });
    } catch (err) {
      console.error("setCaringFor failed:", err);
    }
    const updatedUser = { ...userObj, caringFor };
    setUser(updatedUser);
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, setLoginRole, setCaringFor, loading }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;
